"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iReliablePartnerStatusErrorEvent = exports.iReliablePartnerStatusEvent = exports.UPDATE_RELIABLE_PARTNER_STATUS_FAILURE = exports.UPDATE_RELIABLE_PARTNER_STATUS_SUCCESS = void 0;
const t = require("io-ts");
exports.UPDATE_RELIABLE_PARTNER_STATUS_SUCCESS = 'UPDATE_RELIABLE_PARTNER_STATUS_SUCCESS';
exports.UPDATE_RELIABLE_PARTNER_STATUS_FAILURE = 'UPDATE_RELIABLE_PARTNER_STATUS_FAILURE';
const iMessage = t.intersection([
    t.interface({
        status: t.string,
        lastCheckedAt: t.string
    }),
    t.partial({
        updatedAt: t.string,
        participantUuid: t.string,
        isStatusChanged: t.string
    })
]);
const iErrorMessage = t.interface({
    error: t.string,
    participantUuid: t.string
});
exports.iReliablePartnerStatusEvent = t.interface({
    event: t.literal(exports.UPDATE_RELIABLE_PARTNER_STATUS_SUCCESS),
    message: iMessage
});
exports.iReliablePartnerStatusErrorEvent = t.interface({
    event: t.literal(exports.UPDATE_RELIABLE_PARTNER_STATUS_FAILURE),
    message: iErrorMessage
});
//# sourceMappingURL=reliablePartnerStatusEvent.js.map